import { css } from "styled-system/css";
import type { ReactNode } from "react";

export function AdminPageShell({
  title,
  description,
  actions,
  children,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={css({ display: "flex", flexDir: "column", gap: "6" })}>
      <div
        className={css({
          display: "flex",
          flexDir: { base: "column", sm: "row" },
          alignItems: { base: "stretch", sm: "flex-start" },
          justifyContent: "space-between",
          gap: "4",
        })}
      >
        <div>
          <p className={css({ fontSize: "xs", letterSpacing: "widest", color: "#64748b", mb: "2" })}>SUPERADMIN</p>
          <h1 className={css({ fontSize: "2xl", fontWeight: "bold", letterSpacing: "tight", color: "#0f172a" })}>{title}</h1>
          {description ? (
            <p className={css({ fontSize: "sm", color: "#64748b", mt: "2", maxW: "2xl", lineHeight: "relaxed" })}>
              {description}
            </p>
          ) : null}
        </div>
        {actions ? <div className={css({ flexShrink: 0 })}>{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}
